import { Faro, getWebInstrumentations, initializeFaro, InternalLoggerLevel } from "@grafana/faro-web-sdk";
import { FaroSessionSpanProcessor, FaroTraceExporter, TracingInstrumentation } from "@grafana/faro-web-tracing";
import { BatchSpanProcessor, WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { Config } from "../config";

export type FaroConfig = {
    endPoint?: string
    key?: string;
    name?: string;
    environment?: string;
    version?: string
}

export const withFaro = (provider: WebTracerProvider, config: Config): [WebTracerProvider, string] => {
    const { faro_endpoint: endpoint, faro_key: apiKey, tracer_name: name, environment, version } = config
    if (!endpoint || !apiKey) return [provider, ""];

    const faro = initializeFaro({
        url: [endpoint, apiKey].map(s => s.replace(/\/$/, "")).join('/'),
        app: {
            name,
            environment,
            version,
        },
        instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()],
        internalLoggerLevel: InternalLoggerLevel.OFF
    });

    const faroSession = new FaroSessionSpanProcessor(new BatchSpanProcessor(new FaroTraceExporter({ ...faro })), faro.metas);
    provider.addSpanProcessor(faroSession);

    window.fetch = wrapFetch(faro, [endpoint]);

    console.debug("Faro attached", { endpoint, name, environment, version });

    return [provider, endpoint]
}


const wrapFetch = (faro: Faro, ignoreUrls: string[] = []) => {
    const currentSessionId = faro.api.getSession()?.id
    const { trace, context } = faro.api.getOTEL() || {};

    if (!currentSessionId || !trace || !context) {
        return window.fetch
    }

    return new Proxy<typeof fetch>(window.fetch, {
        apply: function (target, that, args: [RequestInfo | URL, RequestInit?]) {
            var [reqInfo, init] = args;

            const isIgnored = ignoreUrls.some(url => reqInfo.toString().indexOf(url) >= 0)
            if (isIgnored) return target.apply(that, args);

            const newHeaders: HeadersInit = {
                "faro-session": currentSessionId,
            };

            if (init) {
                init.headers = {
                    ...init.headers,
                    ...newHeaders
                };
            } else {
                init = { headers: newHeaders }
            }

            return target.apply(that, args);
        }
    })
}